import { type PropsWithChildren } from 'react';

import { DownloadData } from './DownloadData.js';
import type { ChartToolbarProps } from '../../types/toolbar.js';

/**
 * ChartToolbar slot component.
 * TODO APPDEV-15613: Remove deprecated ChartToolbar component
 */
const ChartToolbarRoot = ({
  children,
}: PropsWithChildren<ChartToolbarProps>) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  (<>{children}</>)
);

ChartToolbarRoot.displayName = 'ChartToolbar';

/**
 * ChartToolbar Slots
 * @public
 *
 * @deprecated Use chart-specific Toolbar slot instead (e.g. \<CategoricalBarChart.Toolbar /\>).
 */
export const ChartToolbar = Object.assign(ChartToolbarRoot, {
  /**
   * @deprecated Use chart specific toolbar item slots instead (e.g. \<CategoricalBarChart.DownloadCSV /\>).
   */
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  DownloadData,
});
